import React from "react";
import { TableSortLabel } from "@mui/material";
import { SortLabelProps } from "./types";

const classNameBase = "scd-table-sort-label";
export default function SortLabel(props: SortLabelProps): React.ReactElement {
  return (
    <TableSortLabel
      tabIndex={-1}
      classes={{
        root: `${classNameBase}-root`,
        active: `${classNameBase}-active`,
        icon: `${classNameBase}-icon`,
        iconDirectionDesc: `${classNameBase}-icon-direction-desc`,
        iconDirectionAsc: `${classNameBase}-icon-direction-asc`,
      }}
      active={props.active}
      direction={props.direction}
      onClick={props.onClick}
    >
      {props.children}
    </TableSortLabel>
  );
}
